import { useState } from 'react';
import classNames from 'classnames';
import { Wishlist } from 'shared/types/wishlist';
import { LineItem } from 'shared/types/wishlist/LineItem';
import { Heart } from 'components/gruenland/icons/Heart';

interface WishlistButtonProps {
  lineItem: LineItem;
  className?: string;
  data?: Wishlist;
  icoWidth?: number;
  addToWishlist?: (lineItem: LineItem, count: number) => Promise<void>;
  removeFromWishlist?: (item: LineItem) => Promise<void>;
}

const WishlistButton: React.FC<WishlistButtonProps> = ({
  lineItem,
  className,
  data,
  icoWidth,
  removeFromWishlist,
  addToWishlist,
}) => {
  const [processing, setProcessing] = useState(false);

  const onWishlist = !!data?.lineItems?.find(({ variant }) => variant?.sku === lineItem.variant?.sku);

  const handleAddToWishList = async () => {
    await addToWishlist?.(lineItem, 1);
  };

  const onRemoveFromWishlist = async () => {
    if (onWishlist) {
      const item = data?.lineItems?.find(({ variant }) => variant?.sku === lineItem.variant?.sku);

      if (item) await removeFromWishlist?.(item);
    }
  };

  const onClick = async () => {
    if (processing) return;
    setProcessing(true);
    if (onWishlist) {
      await onRemoveFromWishlist?.();
    } else {
      await handleAddToWishList?.();
    }
    setProcessing(false);
  };

  return (
    <button onClick={onClick} className={classNames('flex items-center justify-center', className)}>
      <Heart
        className={classNames({
          'text-red-500': onWishlist,
        })}
        width={icoWidth}
      />
    </button>
  );
};

export default WishlistButton;
